// extracted by mini-css-extract-plugin
export default {"group":"group__8uh8d","heading":"heading__VRZvJ","description":"description__-IXAl","content":"content__-q+MR"};